import logger from './logger';
import { DEFAULT_UPLOAD_SIZE_BYTES } from '../constants/limits';

/**
 * Fetches the max upload size from the Matrix server's media config.
 * Falls back to DEFAULT_UPLOAD_SIZE_BYTES if fetch fails or value is missing.
 *
 * Uses the authenticated media endpoint (/_matrix/client/v1/media/config)
 * which is required when the server has enable_authenticated_media: true.
 *
 * @param {import('matrix-js-sdk').MatrixClient} client
 * @returns {Promise<number>} Max upload size in bytes
 */
export async function getMaxUploadSize(client) {
  if (!client) {
    logger.warn('getMaxUploadSize: No client provided, using default');
    return DEFAULT_UPLOAD_SIZE_BYTES;
  }

  try {
    // Use authenticated media endpoint (true) since server has enable_authenticated_media: true
    const config = await client.getMediaConfig(true);
    const uploadSize = config?.['m.upload.size'];

    if (typeof uploadSize === 'number' && uploadSize > 0) {
      logger.debug('Media config m.upload.size:', uploadSize);
      return uploadSize;
    }

    logger.debug('No m.upload.size in config, using default');
    return DEFAULT_UPLOAD_SIZE_BYTES;
  } catch (error) {
    logger.warn('Failed to fetch media config, using default:', error.message);
    return DEFAULT_UPLOAD_SIZE_BYTES;
  }
}
